import React from 'react'

const MessageData = ({isMyMessage, messagedata, messageTime, include}) => {
    return (
        <div className={isMyMessage ? "message-element-left" :include? "message-element-mid" : "message-element-right"} >
            <span className="msg-data">{messagedata && messagedata}</span>
            <p className="time">{messageTime && messageTime}</p>
        </div>
    )
}

export default MessageData
